import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { GlobalState } from "@/Reducers/interface";

export const useUserReady = () => {
	const {
		userData,
		userCompany,
		companyUserList,
		configurationSettings,
		billingInfo,
		subscriptions
	} = useSelector((state: GlobalState) => ({
		userData: state.user.userData,
		userCompany: state.user.userCompany,
		companyUserList: state.user.companyUserList,
		configurationSettings: state.user.configurationSettings,
		billingInfo: state.user.billingInfo,
		subscriptions: state.user.subscriptions
	}));
	const [isUserReady, setUserReady] = useState(false);
	const newValue =
		!!userData &&
		userData.id?.length > 0 &&
		!!userCompany &&
		userCompany.id?.length > 0 &&
		!!companyUserList &&
		!!configurationSettings;
	useEffect(() => {
		if (isUserReady !== newValue) {
			setUserReady(newValue);
		}
	}, [
		userData,
		userCompany,
		companyUserList,
		configurationSettings,
		isUserReady,
		subscriptions
	]);
	return [
		isUserReady || isUserReady !== newValue
			? { userData, userCompany, billingInfo, subscriptions, isUserReady }
			: null
	];
};
